import { ClampexType, C_VALUE } from "../../types/types";


export enum ProductActionTypes {
    FETCH_PRODUCT_CVALUES_REQUEST = '@@product/FETCH_PRODUCT_CVALUES_REQUEST',
    FETCH_PRODUCT_CVALUES_SUCCESS = '@@product/FETCH_PRODUCT_CVALUES_SUCCESS',
    FETCH_PRODUCT_CVALUES_ERROR = '@@product/FETCH_PRODUCT_SIZES_ERROR',
    FETCH_PRODUCT_SIZES_REQUEST = '@@product/FETCH_PRODUCT_SIZES_REQUEST',
    FETCH_PRODUCT_SIZES_SUCCESS = '@@product/FETCH_PRODUCT_SIZES_SUCCESS',
    FETCH_PRODUCT_SIZES_ERROR = '@@product/FETCH_PRODUCT_SIZES_ERROR',
    FETCH_PRODUCT_METADATA_REQUEST = '@@product/FETCH_PRODUCT_METADATA_REQUEST',
    FETCH_PRODUCT_METADATA_SUCCESS = '@@product/FETCH_PRODUCT_METADATA_SUCCESS',
    FETCH_PRODUCT_METADATA_ERROR = '@@product/FETCH_PRODUCT_METADATA_ERROR',
    FETCH_PRODUCT_ATTRIBUTES_REQUEST = '@@product/FETCH_PRODUCT_ATTRIBUTES_REQUEST',
    FETCH_PRODUCT_ATTRIBUTES_SUCCESS = '@@product/FETCH_PRODUCT_ATTRIBUTES_SUCCESS',
    FETCH_PRODUCT_ATTRIBUTES_ERROR = '@@product/FETCH_PRODUCT_ATTRIBUTES_ERROR',
    PRODUCT_CALCULATION_REQUEST = '@@product/FETCH_PRODUCT_CALCULATION_REQUEST',
    PRODUCT_CALCULATION_SUCCESS = '@@product/FETCH_PRODUCT_CALCULATION_SUCCESS',
    PRODUCT_CALCULATION_ERROR = '@@product/FETCH_PRODUCT_CALCULATION_ERROR',
    UPDATE_PRODUCT= '@@product/UPDATE_PRODUCT',
    UPDATE_INPUT_DATA= '@@product/UPDATE_INPUT_DATA',
    PRODUCT_OPEN_DATASHEET = '@@PDF/OPEN_PDF_DATASHEET',
    PRODUCT_OPEN_DATASHEET_ERROR = "@@PDF/OPEN_PDF_DATASHEET_ERROR",
    PRODUCT_BROWSER_OPENED = '@@PDF/OPEN_PDF_BROWSER_OPENED',
    UPDATE_INPUT_DATA_REQUIRED_FIELDS= '@@product/UPDATE_INPUT_DATA_REQUIRED_FIELDS',
    FETCH_PRODUCT_MATERIAL_REQUEST = '@@product/FETCH_PRODUCT_MATERIAL_REQUEST',
    FETCH_PRODUCT_MATERIAL_SUCCESS = '@@product/FETCH_PRODUCT_MATERIAL_SUCCESS',
    FETCH_PRODUCT_MATERIAL_ERROR = '@@product/FETCH_PRODUCT_MATERIAL_ERROR'

}


//This interface is only for the input data in the url 
export interface ProductInputDataURL {
    c_value?: number |  null, // c_value?: number |  null,
    hid?: number |  null, //hubInnerDiameter_D?: number |  null,
    hod?: number |  null, //hubOuterDiameter?: number |  null,
    torque?:  number | null, //torque?:  number | null,
    af?:  number |  null, // axialForce?:  number |  null,
    rs?:  number |  null, //rotationSpeed?:  number |  null,
    yss?: number |  null, //yieldStrengthShaft?: number |  null,
    sd?: number |  null, //shaftDiameter_d?: number |  null,
    sid?: number |  null, //shaftInnerDiameter_diw?: number |  null,
    ysh?: number |  null, //yieldStrengthHub?: number |  null,
    msh?: number |  null, // materialDensityHub?: number |  null,
    spf?:number | null, //screwPreloadForce?:number | null,
    hw?: number |  null,// hubWidth?: number |  null,
    sbtop?: number,//screwBoltingTorqueOverwritePercentage?: number,
    sbt?: number|  null, // screwBoltingTorque_Ts?: number|  null,
}

//because of the default value " " everything is also a string. If i set the default value to undefined or null react will determine that this is an uncontrolled component and 
//will throw an error. I can also set the default value to the number 0 but i dont want that the number 0 is via default also in the textbox. The actual number in the redux store is stored as "number" not as string! 
export interface ProductInputData {
    storageKey?: string //only for the save function to local browser storage
    date?: string  //only for the save function to local browser storage
    c_value?: number |  null,
    hubInnerDiameter_D?: number |  null,
    hubOuterDiameter?: number |  null,
    torque?:  number | null,
    axialForce?:  number |  null,
    rotationSpeed?:  number |  null,
    yieldStrengthShaft?: number |  null,
    shaftDiameter_d?: number |  null,
    shaftInnerDiameter_diw?: number |  null,
    yieldStrengthHub?: number |  null,
    materialDensityHub?: number |  null,
    screwPreloadForce?:number | null,
    hubWidth?: number |  null,
    screwBoltingTorqueOverwritePercentage?: number,
    screwBoltingTorque_Ts?: number|  null,
    errorFields?: ProductInputDataRequiredFields,
    shaftMaterial?:string, //only for the datasheet
    hubMaterial?:string //only for the datasheet
}

export interface ProductInputDataRequiredFields {
    c_value?: boolean,
    hubInnerDiameter_D?: boolean,
    hubOuterDiameter?: boolean,
    torque?:  boolean,
    axialForce?:  boolean,
    rotationSpeed?:  boolean,
    yieldStrengthShaft?: boolean,
    shaftDiameter_d?: boolean,
    shaftInnerDiameter_diw?: boolean,
    yieldStrengthHub?: boolean,
    materialDensityHub?: boolean,
    screwPreloadForce?:boolean,
    hubWidth?: boolean,
    screwBoltingTorqueOverwritePercentage?: boolean,
    screwBoltingTorque_Ts?: boolean,
}

export interface ProductData {
    inStock: boolean,
    price:number | null,
    descriptionDE: string
    descriptionExtendedDE : string
    descriptionExtendedEN : string
    matNr:string
}

export interface CalculationOutputData {
    resultingTransmittableTorque: number
    resultingTransmittableAxialForce: number,
    resultingSurfacePressureCEShaft: number,
    resultingSurfacePressureCEHub: number,
    necessaryHubOuterDiameter: number,
    permissibleShaftInnerDiameter: number,
    tangentialStressShaft: number,
    tangentialStressHub: number,
    tangentialStressShaftWithInnerDiam: number,
    safetyFactorTorque: number,
    safetyFactorAxialForce: number,
    resultingTotalTorque: number
}

export interface ClampexTypeAttributes {
    size: number,
    image: string,
    assemblyManualEN: string,
    assemblyManualDE: string,
    catalogueURLDE: string,
    catalogueURLEN: string
}

export interface Material {
    name: string,
    yieldstrength: number
}

export interface Clampex {
    clampexType:ClampexTypeAttributes,
    materials: Array<Material>,
    type: ClampexType,
    c_VALUES: Array<C_VALUE>,
    sizes: Array<ClampexSizes>,
    shaftDiameter_d?: number;
    hubInnerDiameter_D?: number;
    dimension_B?:number,
    dimension_B1?:number,
    dimension_B2?:number,
    dimension_B3?:number,
    dimension_Ds?:number,
    dimension_D1?:number,
    coneAngle?:number,
    weight_kg?:number,
    screwSize?:number,
    screwNumber?:number,
    screwLength_mm?:number,
    screwClass?:number,
    screwBoltingTorque_Ts?:number,
    screwPreloadForce_Fv?:number,
    cat_AxialForce_T?:number,
    cat_AxialForce_fax?:number,
    transferableAxialForce_T?:number,
    cat_SurfacePressureShaft_PW?:number,
    cat_SurfacePressureHub_PN?:number,
    factor?:number,
    clampingForce_PO?:number,
    clampingForce_PS?:number,
    clampingForce_PA?:number,
    loading?: boolean
    productData?: ProductData,
    calculationOutputData?: CalculationOutputData
}

export interface ClampexSizes {
    shaftDiameter_d: number,
    hubInnerDiameter_D: number
}